import { useEffect, useState } from 'react';
import { payrollGlobalApi as papi } from '../../../api/payrollGlobal.js';

/** Pay-component library: list + create. */
export default function ComponentsPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  async function load() {
    setLoading(true);
    try {
      setItems((await papi.listComponents())?.items || []);
    } catch (e) {
      setError(e.response?.data?.message || 'Failed to load components');
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => { load(); }, []);

  async function createComponent(e) {
    e.preventDefault();
    const fd = new FormData(e.currentTarget);
    const form = e.currentTarget;
    setBusy(true);
    setError(null);
    try {
      const config = {};
      if (fd.get('calc') === 'fixed') config.amountCents = Number(fd.get('amount') || 0);
      if (fd.get('calc') === 'percent_of_base') config.rate = Number(fd.get('rate') || 0);
      if (fd.get('calc') === 'formula') config.formula = fd.get('formula') || '';
      await papi.createComponent({
        code: fd.get('code'), name: fd.get('name'), type: fd.get('type'), calc: fd.get('calc'),
        config, glAccountCode: fd.get('glAccountCode') || null, taxable: fd.get('taxable') === 'on',
      });
      form.reset();
      await load();
    } catch (e2) {
      setError(e2.response?.data?.message || 'Save failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <section data-testid="payroll-global-components-page" data-loading={loading || busy ? 'true' : 'false'}>
      <header className="page-header"><div><h1>Component Library</h1><p className="muted">Configurable earnings, deductions, employer costs and taxes.</p></div></header>
      {error && <div className="alert error" data-testid="payroll-global-components-error">{error}</div>}

      <form onSubmit={createComponent} className="card form-card grid-form">
        <label>Code<input name="code" data-testid="payroll-global-component-code-input" required /></label>
        <label>Name<input name="name" data-testid="payroll-global-component-name-input" required /></label>
        <label>Type
          <select name="type" data-testid="payroll-global-component-type-input" defaultValue="earning">
            <option value="earning">earning</option><option value="deduction">deduction</option>
            <option value="employer_cost">employer_cost</option><option value="tax">tax</option>
          </select>
        </label>
        <label>Calc
          <select name="calc" data-testid="payroll-global-component-calc-input" defaultValue="fixed">
            <option value="fixed">fixed</option><option value="percent_of_base">percent_of_base</option>
            <option value="formula">formula</option><option value="statutory">statutory</option>
          </select>
        </label>
        <label>Amount (cents)<input name="amount" type="number" data-testid="payroll-global-component-amount-input" /></label>
        <label>Rate (fraction)<input name="rate" type="number" step="0.0001" data-testid="payroll-global-component-rate-input" /></label>
        <label>Formula<input name="formula" data-testid="payroll-global-component-formula-input" placeholder="base * 0.1" /></label>
        <label>GL account code<input name="glAccountCode" data-testid="payroll-global-component-gl-input" placeholder="7000" /></label>
        <label className="checkbox">Taxable<input name="taxable" type="checkbox" data-testid="payroll-global-component-taxable-input" /></label>
        <div className="full actions"><button className="btn primary" type="submit" data-testid="payroll-global-component-create" disabled={busy}>Add component</button></div>
      </form>

      <div className="card">
        <h3>Components</h3>
        <table className="data-table" data-testid="payroll-global-component-list">
          <thead><tr><th>Code</th><th>Name</th><th>Type</th><th>Calc</th><th>GL</th><th>Taxable</th></tr></thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.id} data-testid={`payroll-global-component-row-${c.id}`}>
                <td>{c.code}</td><td>{c.name}</td><td>{c.type}</td><td>{c.calc}</td><td>{c.gl_account_code || '—'}</td><td>{c.taxable ? 'yes' : 'no'}</td>
              </tr>
            ))}
            {!loading && items.length === 0 && <tr><td colSpan={6} className="muted">No components yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
